// MoreSetting.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import { FEATURE_SETTINGS_ABOUT_SWAG } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import sendDataToSentry from '../action/sendDataToSentry.js';
import MoreSetting from '../page/MoreSetting.jsx';

const mapStateToProps = state => {
  return {
    shouldShowAboutSwag:
      getRemoteConfigData(state, FEATURE_SETTINGS_ABOUT_SWAG) === 1,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    close: () => dispatch(goBack()),
    sendDataToSentry: data => dispatch(sendDataToSentry(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MoreSetting);
